import { BFM_Grid_Editor } from "./editor/bfm_grid_editor"
import { BFM_Schema_Editor } from "./editor/bfm_schema_editor"
import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import * as api from "../../api/apiConnector.js";
import { useTranslation } from 'react-i18next';
import UserContext from '../../components/User_Context.js';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as uploadManager from "../../components/ui/fileupload.js";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import * as menu from "../../assets/menus/menu.js";
import waiting from "../../assets/images/waiting.svg";
import * as utils from "../../components/utils.js";

const BFM_Data_Editor = (params) => {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [file, setFile] = useState(null);
    const { currentUser } = useContext(UserContext);
    const { t } = useTranslation();

    useEffect(() => {
        (async () => {
            let _data = await _getData();

            setData({
                data: _data.data
            });

            setFile(_data.file);
            menu.write({ user: currentUser() });

            breadcrumb.set(
                [                        {
                            link: "/",
                            name: t('home', { ns: 'labels' })
                        }].concat(
                    _data.path.reverse().map((f) => {
                        return {
                            name: f.Name,
                            link: `/dms/${f.Id}`
                        }
                    }))
                    .concat(
                        {
                            link: `/aiflow/data/${id}`,
                            name: _data.data.name ?? "data"
                        }
                    )
            );
        })();
    }, []);

    useEffect(() => {
        //nop
    }, [data]);


    const _getData = async () => {
        var result = await api.sendMessage("bfm/getData", {
            user: currentUser(),
            body: {
                id
            }
        });

        return result;
    }

    const _onChange = (params) => {
        setData({
            data: data.data
        });
    }

    const _draw_maindata_editor = (params) => {
        return (<>
            <div class="mb-3">
                <label for="name" class="form-label">{t('name', { ns: 'labels' })}</label>
                <input type="text" class="form-control" id="name" aria-describedby="nameHelp" value={data.data.name}
                    onChange={(e) => {
                        data.data.name = e.target.value;
                        _onChange();
                    }}
                />
                <div id="nameHelp" class="form-text" >{t('nameUsedForFlowsAndMacros', { ns: 'labels' })} <strong>{utils.code_name(data.data.name)}</strong></div>
            </div>
            <div class="mb-3">
                <label for="description" class="form-label">{t('description', { ns: 'labels' })}</label>
                <textarea rows="5" class="form-control" id="description" value={data.data.description} onChange={(e) => {
                    data.data.description = e.target.value;
                    _onChange();
                }}></textarea>
            </div>
            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" id="isArray" checked={data.data.isArray} aria-describedby="isArrayHelp"
                    onChange={(e) => {
                        data.data.isArray = !data.data.isArray;
                        _onChange();
                    }}
                />
                <label class="form-check-label" for="isArray">{t('isArrayMultipleRows', { ns: 'labels' })}</label>
                <div id="isArrayHelp" class="form-text">{t('isArrayDescription', { ns: 'labels' })}</div>
            </div>
        </>)
    }

    const _draw_editor = (params) => {
        return (
            <>
                <ul class="nav nav-tabs" id="tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="main-tab" data-bs-toggle="tab" data-bs-target="#main-content" type="button" role="tab" aria-controls="main-content" aria-selected="true">{t('main', { ns: 'labels' })}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="schema-tab" data-bs-toggle="tab" data-bs-target="#schema-content" type="button" role="tab" aria-controls="schema-content" aria-selected="false">{t('schema', { ns: 'labels' })}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="data-tab" data-bs-toggle="tab" data-bs-target="#data-content" type="button" role="tab" aria-controls="data-content" aria-selected="false">{t('data', { ns: 'labels' })}</button>
                    </li>
                </ul>
                <div class="tab-content" id="tabs-content" style={{ padding: 15 }}>
                    <div class="tab-pane fade active show" id="main-content" role="tabpanel" aria-labelledby="main-tab">
                        <p class="lead">
                            {t('generalInformation', { ns: 'labels' })}
                        </p>
                        {_draw_maindata_editor()}
                    </div>
                    <div class="tab-pane fade" id="schema-content" role="tabpanel" aria-labelledby="schema-tab">
                        <p class="lead">
                            {t('schemaDefinition', { ns: 'labels' })}
                        </p>
                        <BFM_Schema_Editor fields={data.data.schema} onChange={(e) => {
                            data.data.schema = e;
                            _onChange();
                        }} ></BFM_Schema_Editor>
                    </div>
                    <div class="tab-pane fade" id="data-content" role="tabpanel" aria-labelledby="data-tab">
                        <p class="lead">
                            {t('dataContent', { ns: 'labels' })}
                        </p>
                        <BFM_Grid_Editor fields={data.data.schema} data={data.data.data} onChange={(e) => {
                            data.data.data = e;
                            _onChange();
                        }} ></BFM_Grid_Editor>
                    </div>

                </div>

            </>
        )
    }

    const _save = async () => {
        const _file = new File([JSON.stringify(data.data)], file.Name);

        uploadManager.fileUpload({
            files: [_file],
            parentId: file.ParentId,
            user: currentUser(),
            onFileAdded: (e) => {
                withReactContent(Swal).fire({
                    title: t('fileSaved', { ns: 'labels' }),
                    icon: "success",
                    text: t('yourDataWasSuccessfullySaved', { ns: 'labels' }),
                    showConfirmButton: true
                });
            }
        })
    }


    const _draw_body = (params) => {
        if (data) {
            return (<>
                <div class="page-titles">
                    <ol class="breadcrumb">

                    </ol>
                    <a class="text-primary fs-13" onClick={(e) => {
                        _save();
                    }} role="button" aria-controls="offcanvasExample1" title={t('saveThisData', { ns: 'labels' })}><i class="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div class="col-xl-12">
                            <div class="card">
                                <div class="card-body p-0">
                                    {_draw_editor()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            );
        } else {
            return (<div class="text-center"><img src={waiting} /></div>);
        }
    }

    return (<>{_draw_body()}</>)
}

export { BFM_Data_Editor }